module.exports = __webpack_public_path__ + "f939f20b37caaa8e99bcd2e0ef22436c.woff";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-LightItalic.woff
// module id = 363
// module chunks = 0